<template>
  <div class="p-chat-system-message">
    <p class="p-chat-system-message__text">{{ text }}</p>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ text: string }>()
</script>

<style lang="scss" scoped>
.p-chat-system-message {
  padding: 4px 24px; // Figma node 5192:16618 / 5194:51068: py-xsmall(4px) px-xlarge(24px)
  text-align: center;

  &__text {
    font-size: 16px;
    line-height: 22px; // Body/Body 16 per Figma node 5192:16618
    color: var(--fg-primary);
    margin: 0;
  }
}
</style>
